import React from 'react'
import { LandingPageImport } from '../Import'
const { ChevronLeft, ChevronRight, GitCommitHorizontal, Slider, TextAnimate, memories_img_1, memories_img_2, memories_img_3, memories_img_4, memories_img_5, memories_img_6 } = LandingPageImport

const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next-arrow" onClick={onClick}>
        <ChevronRight size={30} />
    </div>
);

const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev-arrow" onClick={onClick}>
        <ChevronLeft size={30} />
    </div>
);

export default function Memories() {

    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    return (
        <>
            <div className="memories padding-100">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 m-auto">
                            <div className='hero_title'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    LAST YEAR MEMORY
                                </h5>
                            </div>

                            <div className="hero_sub_title">
                                <h2><TextAnimate text="Recent Memories 2025" /></h2>
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="mt-5">
                                <Slider {...settings}>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_1}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_2}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_3}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_4}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_5}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="event-card ms-5">
                                            <img
                                                src={memories_img_6}
                                                alt="event"
                                                className="event-image"
                                            />
                                            <div className="flag-hover">
                                                <div className="flag-content">
                                                    <p className="flag-sub">EVENT 2024</p>
                                                    <h4 className="flag-title">Event Conferences</h4>
                                                </div>
                                                <div className="plus-icon">+</div>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
